<script lang="ts">

  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import { MANAGER_ID, SUPERADMIN_ID } from "../environment";
  import { meService } from "../Services";

  const defaultNavigation = {
    [SUPERADMIN_ID] : '/cuentas',
    [MANAGER_ID]    : '/manager',
  };

  onMount(async () => {
    const me = await meService.getMePromise()
    navigate(defaultNavigation[me.typeId.value])
  })

</script>

Redireccionando...
